import React from 'react';
import {Spinner} from '../../reusable-components';
import styled from 'styled-components';

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5rem;
`;
const CustomSpinner = ({
  style = {},
  className = '',
  size = undefined,
  ...rest
}) => (
  <StyledDiv className={className} data-testid="container-pending">
    <Spinner size={size} {...rest} />
  </StyledDiv>
);

export default CustomSpinner;
